import PartsSection from "../sections/PartsSection";
import { PlusCircleIcon } from "@heroicons/react/24/solid";
import { useWorkorderContext } from "../../../../../context/WorkorderContext";
import { Button } from "@material-tailwind/react";
import { t } from "i18next";

interface PartsTabProps {
  workorder: EasyTech.Workorder | null;
  canEdit?: boolean;
}

const PartsTab: React.FC<PartsTabProps> = ({
  workorder,
  canEdit = true
}) => {
  const { setInlineAdd, inlineAdd, setCurrentEditContext, editingPartId } =
    useWorkorderContext();

  // Gestionnaire pour l'ajout de part avec contexte
  const handleAddPart = () => {
    // Si on est déjà en train d'éditer une pièce, on ne peut pas en ajouter une nouvelle
    if (editingPartId) return;

    // Définir le contexte d'édition global au niveau workorder
    setCurrentEditContext(`workorder-${workorder?.id}`);
    setInlineAdd(!inlineAdd);
  };

  if (!workorder) return null;

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-medium text-gray-900">
          {t("workorder:editIntervention")} <span className="text-gray-500 text-sm">{workorder.ref}</span>
        </h2>
        <Button
          onClick={handleAddPart}
          variant="filled"
          size="md"
          className="flex items-center gap-2 bg-blue-50 shadow-md text-sm text-blue-500 px-3 rounded-lg font-thin normal-case"
          disabled={!canEdit || !!editingPartId}
        >
          <PlusCircleIcon className="h-5 w-5 text-blue-500" />
          {t("workorder:addPart")}
        </Button>
      </div>
      <PartsSection workorderId={workorder.id} targetType="workorder" canEdit={canEdit} />
    </div>
  );
};

export default PartsTab;
